import React, { useEffect, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./sidebarExtension.css";

import Activitytypes from "./ActivityTypes/activityTypes";
import Searchbar from "./Searchbar/searchbar";
import Sliders from "./Sliders";
import { fetchSubtypes, fetchMastersData, fetchActivityTypes, fetchDuonutCategories } from "../../../services/activity";
import { setSubtypes, setSubtypesMasters, updateActivityTypes, toggleIsLoading, selectSingleActivityType } from "../../../redux/slices/activityTypes";
import { updateCategories } from "../../../redux/slices/duonutSettings";
import { useDisableBodyScroll } from "../../../hooks/useDisableBodyScroll";
import { addUserActivity, removeUserActivity, setDefaultSelectedActivity, toggleVideoVisible } from "../../../redux/slices/userActivity";
import Loader from "../../Loader";
import VideoImg from '../../../assets/video.png'

import VideoLeftIcon from '../../../assets/icons/video-left.svg'
import VideoLeftActiveIcon from '../../../assets/icons/video-left-active.svg'
import VideoRightIcon from '../../../assets/icons/video-right.svg'
import VideoRightActiveIcon from '../../../assets/icons/video-right-active.svg'
import VideoBottomIcon from '../../../assets/icons/video-bottom.svg'
import VideoBottomActiveIcon from '../../../assets/icons/video-bottom-active.svg'

function SidebarExtension({ duonutId }) {
  //states for mobile view to toggle activity type slider visibility
  const [extensionCollapsed, setExtensionCollapsed] = useState(true);
  const toggleExtensionCollapse = () => setExtensionCollapsed(!extensionCollapsed);

  const dispatch = useDispatch();

  const { activityTypes, isLoading } = useSelector((state) => state.activityTypes);
  const { categories, selectedCategoryName } = useSelector((state) => state.activityCategories);
  const [isSubtypesFetched, setIsSubtypesFetched] = useState(false)
  const { userActivities, selectedUserActivity, defaultSelectedActivity, defaultUserActivities, isEditing, isVideo } = useSelector((state) => state.userActivity);

  useDisableBodyScroll(!extensionCollapsed);
  // console.log(isVideo);
  useEffect(() => {
    if (defaultSelectedActivity.isSet === true) return;
    // if (defaultSelectedActivity.id === null && defaultSelectedActivity.isSet === true) return
    let selectedType = activityTypes.filter((type) => type.id === defaultSelectedActivity.id);
    if (selectedType.length === 0 || selectedType[0].subtypes.length === 0) return;
    if (selectedType.length === 0 || selectedType[0].subtypes[0].masters_data.length === 0) return;

    let masters = selectedType[0].subtypes[0].masters_data;

    dispatch(addUserActivity(masters[0]));
    dispatch(removeUserActivity({ idx: 0 }));
    dispatch(setDefaultSelectedActivity({ defaultSelectedActivity: { id: 1, isSet: true } }));

    dispatch(selectSingleActivityType({ id: defaultSelectedActivity.id }))
  }, [activityTypes, defaultSelectedActivity]);

  const getSubTypes = () => {
    fetchSubtypes((err, res) => {
      if (err) return;
      // dispatch(toggleIsLoading(false))
      // console.log('subtypesdata', res.data)
      res.data.map((subtype) => {
        dispatch(setSubtypes({ subtype: { ...subtype, masters_data: [] }, activityTypeId: subtype.activity_type_id }));
      })
      setIsSubtypesFetched(true)
    })

  };

  // console.log(activityTypes)

  useEffect(() => {
    if (isSubtypesFetched === false) return;
    let totalTypesLength = activityTypes.length
    let typeIds = []
    activityTypes.map(async activityType => {
      activityType.subtypes.map(subtype => {
        fetchMastersData(activityType.name, subtype.name, 1, (err, res) => {
          if (err) return console.log(err)
          // console.log(subtype.name)
          // console.log('masters' ,res.data.results)
          dispatch(setSubtypesMasters({
            activityTypeId: activityType.id,
            subtypeId: subtype.id,
            data: res.data.results
          }))
          if (!typeIds.includes(activityType.id)) typeIds.push(activityType.id)
          if (typeIds.length === totalTypesLength) {
            // console.log(activityType.subtypes[activityType.subtypes.length - 1])
            dispatch(toggleIsLoading(false))
          }
        })
      })
    })
  }, [isSubtypesFetched])

  useEffect(() => {
    if (activityTypes.length === 0) return;
    if (activityTypes[0].subtypes.length >= 1) return;
    getSubTypes();
  }, [activityTypes.length])

  const getActivityTypes = () => {
    fetchActivityTypes((err, res) => {
      if (err) return;
      let tempTypes = res.data.map((type) => {
        return { ...type, isSelected: true, subtypes: [] };
      });
      dispatch(updateActivityTypes(tempTypes));
    });
  };


  useEffect(() => {
    fetchDuonutCategories((err, res) => {
      if (err) return console.log(err)
      let tempCategories = res.data.map((category) => {
        let c = { ...category };
        c.value = category.name;
        delete c.name;
        return c;
      });
      dispatch(updateCategories({ categories: tempCategories }));
    });
  }, []);

  useEffect(() => {
    if (activityTypes.length === 0) getActivityTypes();
  }, []);

  const current = userActivities[selectedUserActivity]
  let pos = ''
  if (userActivities[selectedUserActivity] !== undefined) {
    if (userActivities[selectedUserActivity]?.question_id?.timestamp === 0) {
      pos = 'pre'
    }
    if (userActivities[selectedUserActivity]?.question_id?.timestamp > 0) {
      pos = 'on'
    }
    if (userActivities[selectedUserActivity]?.question_id?.timestamp === -1) {
      pos = 'post'
    }
  }

  const showVideo = () => {
    dispatch(toggleVideoVisible({ videoVisible: true }))
  }

  useEffect(() => {
    dispatch(toggleVideoVisible({ videoVisible: false }))
  }, [userActivities, selectedUserActivity])

  return (
    <div className={`sidebar_extension ${isVideo ? 'video' : ''} `} id={extensionCollapsed ? "in-active" : "active"} style={{ overflow: isLoading ? 'hidden' : 'auto' }} >

      <div style={{ flex: 1, overflow: 'auto' }}>
        <div className="up_arrow icon-button" onClick={toggleExtensionCollapse}>
          <img src="/assets/icons/up.svg" alt="icon" />
        </div>
        <Searchbar />
        {activityTypes.length >= 1 && categories.length >= 1 && (
          <>
            <Activitytypes toggleExtensionCollapse={toggleExtensionCollapse} />
            <Sliders toggleExtensionCollapse={toggleExtensionCollapse} />
          </>
        )}
        {isLoading && <div className="slider_loader"> <Loader /> </div>}
      </div>
      {isVideo &&
        <div className="video-thumbnail-container">
          <div className=''>
            <div className="thumbnail-img-container">
              <p>Video</p>
              <img src={pos === 'pre' ? VideoLeftActiveIcon : VideoLeftIcon}
                className='indicator left' />
              <img src={pos === 'post' ? VideoRightActiveIcon : VideoRightIcon}
                className='indicator right' />
              <img src={pos === 'on' ? VideoBottomActiveIcon : VideoBottomIcon}
                className='indicator bottom' />
              <img src={VideoImg} onClick={showVideo} />
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default SidebarExtension